/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IClinicalDictionary } from 'app/shared/model/clinical-dictionary.model';

export interface IOrganism {
  id?: string;
  name?: string;
  genus?: string | null;
  species?: string | null;
  strain?: string | null;
  habitat?: string | null;
  notes?: string | null;
  active?: boolean | null;
  cursor?: number | null;
  lastUpdated?: number | null;
  microSec?: number | null;
  timestampEntry?: number | null;
  type?: IClinicalDictionary | null;
  clinicalSignificance?: IClinicalDictionary | null;
}

export const defaultValue: Readonly<IOrganism> = {
  active: false,
};
